export const googleTranslateLanguages = [
  {
    code: 'es',
    name: 'ES',
    cname: 'ES',
    ename: 'ES',
  },
  {
    code: 'en',
    name: 'EN',
    cname: 'EN',
    ename: 'EN',
  },
  {
    code: 'fr',
    name: 'FR',
    cname: 'FR',
    ename: 'FR',
  },
  {
    code: 'it',
    name: 'IT',
    cname: 'IT',
    ename: 'IT',
  },
  {
    code: 'ca',
    name: 'CA',
    cname: 'CA',
    ename: 'CA',
  },
  {
    code: 'pt',
    name: 'PT',
    cname: 'PT',
    ename: 'PT',
  },
  {
    code: 'eu',
    name: 'EU',
    cname: 'EU',
    ename: 'EU',
  },
  {
    code: 'de',
    name: 'DE',
    cname: 'DE',
    ename: 'DE',
  },
  {
    code: 'tr',
    name: 'TR',
    cname: 'TR',
    ename: 'TR',
  },
];

export const selectableLangCodes = googleTranslateLanguages.map(({ code }) => code);
